import React from 'react'
import { useTranslation } from 'react-i18next'
import { ApolloProvider } from '@apollo/client'
import { ConfigProvider } from 'antd'
import enUS from 'antd/es/locale/en_US'
import thTH from 'antd/es/locale/th_TH'

import PageRouter from 'pages/PageRouter'

import apolloClient from 'config/initializeApolloClient'

import AuthProvider from 'contexts/AuthProvider'
import ThemeProvider from 'contexts/ThemeProvider'

import setupAppLocal, { localeCode } from 'utils/localService/app'
import setupI18n from 'i18n'

import 'configuration'

import 'antd/dist/antd.css'
import 'assets/globalStyle.css'

setupAppLocal()
setupI18n()

const App: React.FC = () => {
  const { i18n } = useTranslation()

  const isThai = i18n.language === localeCode.thTH

  return (
    <ConfigProvider componentSize="large" locale={isThai ? thTH : enUS}>
      <AuthProvider>
        <ApolloProvider client={apolloClient}>
          <ThemeProvider>
            <PageRouter />
          </ThemeProvider>
        </ApolloProvider>
      </AuthProvider>
    </ConfigProvider>
  )
}

export default App
